import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import { useSubsStore } from '@/state/MsgTreeProvider'
import {
  MainMessageAuthorText,
  MainMessageBodyContent,
  MainMessageDatetimeText,
  MainMessageHeadlineSign,
  MainMessageHeadlineText,
  MainMessageTitleText,
  mainMessageAvatarSrc,
  mainMessageEmailAddress,
  mainMessageEmailHref,
} from '../../mainMessageData'

// Caption leaves. Each subscribes to the store on its own so the surrounding
// page chrome stays static (and legacy DOM visibility toggles aren't wiped by
// re-renders). Data comes from TreeStore selectors via the section helpers.

export function Subject({ fallback }: { fallback: string }) {
  const { state } = useSubsStore()
  return <MainMessageTitleText storeState={state as any} fallback={fallback} />
}

export function Author({ fallback }: { fallback: string }) {
  const { state } = useSubsStore()
  return <MainMessageAuthorText storeState={state as any} fallback={fallback} />
}

// LEGACY TITLE RULE (§0.16 desk identity): "@ name_key" on message desks,
// ":: subject" on answer desks — see mainMessageData for the PHP trace.
export function HeadlineSign() {
  const { state } = useSubsStore()
  return <MainMessageHeadlineSign storeState={state as any} />
}

export function Headline({ fallback }: { fallback: string }) {
  const { state } = useSubsStore()
  return <MainMessageHeadlineText storeState={state as any} fallback={fallback} />
}

export function Datetime({ fallback }: { fallback: string }) {
  const { state } = useSubsStore()
  return <MainMessageDatetimeText storeState={state as any} fallback={fallback} />
}

export function BodyContent({ children }: { children: ReactNode }) {
  const { state } = useSubsStore()
  return <MainMessageBodyContent storeState={state as any}>{children}</MainMessageBodyContent>
}

type AvatarImgProps = {
  fallback: string
  className?: string
  title?: string
  style?: ComponentPropsWithoutRef<'img'>['style']
}

export function AvatarImg({ fallback, className, title, style }: AvatarImgProps) {
  const { state } = useSubsStore()
  return <img title={title} src={mainMessageAvatarSrc(state as any, fallback)} className={className} style={style} />
}

export function EmailText({ fallback }: { fallback: string }) {
  const { state } = useSubsStore()
  return <>{mainMessageEmailAddress(state as any, fallback)}</>
}

export function EmailLink({ fallbackHref, fallbackText, className }: { fallbackHref: string; fallbackText: string; className?: string }) {
  const { state } = useSubsStore()
  return (
    <a href={mainMessageEmailHref(state as any, fallbackHref)} className={className}>
      {mainMessageEmailAddress(state as any, fallbackText)}
    </a>
  )
}
